<template>
  <div class="overlay">
    <div class="revisionemail">
      <div class="content-section">
        <h3>Email for Revision Needed</h3>
        <div class="close" @click="onClose"></div>
        <div class="input-container">
          <label for="subject">Subject</label>
          <input class="input" id="subject" v-model="email.subject" />
        </div>
        <div class="textarea-container">
          <label for="body">Body</label>
          <textarea class="textarea" id="body" rows="20" v-model="email.body"></textarea>
        </div>
        <button v-if="type == 'content'" class="button" @click="updateContent(content, 'Revision Needed', 'get this article revisioned')">Confirm</button>
        <button v-if="type == 'linkbuilding'" class="button" @click="updateLinkBuilding(linkbuilding, 'Revision Needed', 'get this article revisioned')">Confirm</button>
        <button v-if="type == 'task'" class="button" @click="updateTask(taskStatus, 'revision-needed', 'get this task revisioned')">Confirm</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      userHasEmail: false,
    }
  },
  props: {
    type: String,
    email: Object,
    linkbuilding: Object,
    content: Object,
    submittedBy: String,
    taskStatus: String,
  },
  methods: {
    onClose() {
      this.$emit('update:modalOpen', false)
    },
    updateTask(currentStatus, newStatus, message) {
      this.$parent.updateTask(currentStatus, newStatus, message)
    },
    updateLinkBuilding(linkbuilding, status, message) {
      this.$parent.updateLinkBuilding(linkbuilding, status, message)
    },
    updateContent(content, status, message) {
      this.$parent.updateContent(content, status, message)
    },
    async fetchEmail() {
      let url = new URL(process.env.VUE_APP_GETUSEREMAIL_URL)
      url.searchParams.set('id', this.submittedBy)
      try {
        const { data } = await axios.get(url)
        if (data !== '<nil>') {
          this.email.recipients = [data]
          this.userHasEmail = true
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
  mounted: function() {
    this.fetchEmail()
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/shared-styles/button.scss';
@import '../assets/shared-styles/input.scss';
@import '../assets/shared-styles/textarea.scss';

select {
  height: 2rem;
}
.revisionemail {
  position: fixed;
  width: 600px;
  z-index: 100;
  left: 50%;
  top: 50%;
  background: white;
  transform: translate(-50%, -50%);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  background: rgba(0, 0, 0, 0.6);
}
.content-section {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem 1.5rem;
  padding: 1.5rem;
  .input-container {
    width: 100%;
  }
  h3 {
    font-size: 1rem;
    grid-column: 1 / -1;
    font-weight: 400;
    margin: 0;
  }
  &:before {
    content: '';
    position: absolute;
    top: calc(100%);
    width: 100%;
    height: 1px;
    background: #ebebf2;
  }
}
.button {
  max-width: none;
}
.close {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  cursor: pointer;
  transition: opacity 0.5s ease-in-out;
  &:after,
  &:before {
    content: '';
    height: 20px;
    width: 20px;
    border-top: 1px solid #43425d;
    position: absolute;
    top: 7px;
    right: -8px;
    transform: rotate(-45deg);
  }
  &:before {
    right: 6px;
    transform: rotate(45deg);
  }
  &:hover:after,
  &:hover:before {
    border-top: 1px solid var(--color-cta);
    top: 6px;
  }
}
</style>
